import type React from 'react';
export const handleEnter = (e: React.KeyboardEvent<HTMLDivElement>, cb: () => void) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        cb();
    }
};
